import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "speech-coach",
	label: "Speech Coach",
	description:
		"Personal communication coach — daily voice-memo drills targeted at your weakest meeting-perf dimensions.",
	version: "0.1.0",
	navItems: [{ label: "Speech Coach", href: "/speech-coach", icon: "Mic" }],
	settings: {
		id: "speech-coach",
		title: "Speech Coach",
		icon: "Mic",
		blurb: "The daily voice-drill reminder.",
		rows: [
			{
				key: "SPEECH_COACH_REMINDER_HOUR",
				label: "Speech Coach reminder hour",
				placeholder: "20",
				restartRequired: true,
				help: "Local hour (0–23) the Speech Coach daily nudge fires. Default 20 (8 PM). Read once at startup when the recurring job is registered — takes effect after a restart.",
			},
		],
	},
};
